import { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { useSportConfiguration } from "~hooks/useSportConfiguration.ts";
import type { LabelValue } from "~types/labelValue.ts";
import CustomSelect from "../CustomSelect";

type Props = {
  className?: string;
  disabled?: boolean;
  defaultValue?: string | { value: string; label: string }[];
  placeholder?: string;
  multiple?: boolean;
  value?: LabelValue | LabelValue[];
  onChange?: (value: LabelValue | LabelValue[] | undefined) => void;
};

const SelectDiscipline = (props: Props) => {
  const { className, disabled, defaultValue, multiple } = props;
  const { disciplines } = useSportConfiguration();

  const options = useMemo(
    () =>
      Object.values(disciplines).map((value) => ({
        value,
        label: value,
      })),
    [disciplines],
  );

  return (
    <CustomSelect
      style={{ minWidth: "130px" }}
      value={props.value}
      defaultValue={defaultValue}
      onChange={(_, option) => {
        if (multiple) {
          props.onChange?.(option as { value: string; label: string }[]);
        } else {
          props.onChange?.(option as { value: string; label: string });
        }
      }}
      options={options}
      placeholder={props.placeholder || <FormattedMessage id="discipline" />}
      allowClear
      className={className}
      disabled={disabled}
      mode={multiple ? "multiple" : undefined}
    />
  );
};

export default SelectDiscipline;
